export const DATA_TEST_ID_PREFIX = 'video-'
export const tooltipTextNotActive = 'Show Transcript'
export const tooltipTextActive = 'Hide Transcript'
export const audioToolTipText = 'Play Video with Audio Description'
export const audioToolTipTextNotActive = 'Play Video Without Audio Description'
